import * as React from "react";
import styled from "styled-components";
import RhumbixLogo from "../../../assets/rhumbix-icon-with-name.png";
import RhumbixWorkersBackground from "../../../assets/background-workers.png";
import { colorMiscGray90, colorFunctionalWhite } from "@rhumbix/rmbx_design_system_design_tokens";
/**
 * @prop {string} id Component id.
 *  @prop {string} [title] CTA title.
 * @prop {string} [description] CTA description.
 * @prop {Object} [pageHistory] Page navigation utils.
 */
const CTAPage = ({ id, title, description, pageHistory, children, }) => {
    return (React.createElement(StyledCTAPage, { id: id },
        React.createElement(StyledContentContainer, null,
            React.createElement(StyledRmbxLogo, { src: RhumbixLogo, alt: "RHUMBIX" }),
            React.createElement(StyledTitle, null, title),
            React.createElement(StyledDescription, null, description),
            children)));
};
export default CTAPage;
const StyledCTAPage = styled.div `
    background-image: url(${RhumbixWorkersBackground});
    background-repeat: no-repeat;
    background-size: cover;
    height: 100vh;
    width: 100vw;
    background-color: ${colorMiscGray90};
    position: relative;
`;
const StyledRmbxLogo = styled.img `
    width: 314px;
    height: 64px;
    margin-bottom: 48px;
    color: ${colorFunctionalWhite};
`;
const StyledContentContainer = styled.div `
    color: ${colorFunctionalWhite};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: fit-content;
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const StyledTitle = styled.h1 `
    font-size: 40px;
    font-family: Roboto;
    margin-bottom: 35px;
    font-weight: 500;
`;
const StyledDescription = styled.div `
    color: ${colorFunctionalWhite}; 
    font-family: Roboto;
    font-size: 22px;
    font-weight: 500;
    margin-top: 22px;
    margin-bottom: 22px;
    max-width: 740px;
`;
